import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskLocation } from '../types/assign-kiosk-types';

export interface GetSparkLocationsResult {
  locations: KioskLocation[];
  assignedLocationId: string | null;
  hasError: boolean;
  errorMessage?: string;
}

export class GetSparkLocationsUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string): Promise<GetSparkLocationsResult> {
    try {
      const { locations, assignedLocationId } = await this.repository.getSparkLocations(machineId);
      return { locations, assignedLocationId, hasError: false };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to load SPARK locations';
      return { locations: [], assignedLocationId: null, hasError: true, errorMessage };
    }
  }
}
